import angular from 'angular';
import PubSub from 'pubsub-js';

/*---------------------------------------------------------*\
 * RegionSelectionLandingController
\*---------------------------------------------------------*/
const deps = {};

class RegionSelectionLandingController {
  //-----------------------------------
  // Constructor
  //-----------------------------------
  constructor($state, navigationService, localService, storageKeys, topics, states) {
    this.name = 'regionSelectionLanding';
    deps.$state = $state;
    deps.localService = localService;
    deps.storageKeys = storageKeys;
    deps.topics = topics;
    deps.states = states;

    this.headerConfig = {
      hideNewsTicker: true,
      hideNavbar: true
    };
    this.region = localService.get(deps.storageKeys.selectedRegion);
    this.listOfRegions = localService.get(deps.storageKeys.regions);
    navigationService.focusElAsync('.main-content' + (this.region ? ' .selected' : ''));
  }

  //-----------------------------------
  // Methods
  //-----------------------------------
  selectRegion(region) {
    if (angular.isObject(region) && !angular.isArray(region)) {
      console.log('## ACTION ## REGION SELECTED', region);
      this.region = region;
      deps.localService.set(deps.storageKeys.selectedRegion, region);
      deps.$state.go(deps.states.home);
      PubSub.publish(deps.topics.regions.select, region);
    }
  }
}

RegionSelectionLandingController.$inject = [
  '$state',
  'navigationService',
  'localService',
  'storageKeys',
  'topics',
  'states'
];

export default RegionSelectionLandingController;



/** WEBPACK FOOTER **
 ** ./client/app/components/regionSelectionLanding/regionSelectionLanding.controller.js
 **/